/**
 * Created by wjjn3481 on 2017/7/18.
 */
import pattern from './pattern.js'

export default {
    name: {required: true, message: '请输入', trigger: 'blur'},
    mobilePhone: [
        {required: true, message: '请输入', trigger: 'blur'},
        {pattern: pattern.phone, message: '手机号格式不正确', trigger: 'blur'}
    ],
    email: [
        {required: true, message: '请输入', trigger: 'blur'},
        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
    ],
    gameExperience: {required: true, message: '请输入', trigger: 'blur'},
    maxMajor: {required: true, message: '请输入', trigger: 'blur'},
    maxSchool: {required: true, message: '请输入', trigger: 'blur'},
    maxDegree: {required: true, message: '请选择', trigger: 'change'},
    positionId: {required: true, message: '请选择', trigger: 'change'},
    expectCityId: {required: true, message: '请选择', trigger: 'change'},
    resumeSource: {required: true, message: '请选择', trigger: 'change'},
    gender: {required: true, message: '请选择'},
    acceptRegulate: {required: true, message: '请选择'},
    recommendable: {required: true, message: '请选择'}
}


// WEBPACK FOOTER //
// ./src/modules/rules.js